import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { FormattedText, Typography } from "client/Components";
import { setTrackingId } from "client/Misc/utils";
import { InlineIcon } from "./InlineIcon/InlineIcon";
import { KnowledgeItemCommentNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { getComputedDisplayName } from "client/Features/AddressBook/common";

export type KnowledgeItemCommentActivityProps = {
	data: KnowledgeItemCommentNotificationDataViewModel;
};

export const KnowledgeItemCommentActivity = (props: KnowledgeItemCommentActivityProps): ReactElement => {
	const { data } = props;

	const {
		title,
		firstname,
		lastname,
	} = data;

	const {
		computedDisplayName
	} = getComputedDisplayName({
		firstName: firstname,
		lastName: lastname
	});

	return (
		<span {...setTrackingId("title")}>
			<InlineIcon icon="comment" />
			<FormattedText
				text={localize("_UserXCommentedOnTitleY")}
				thingsToReplace={[
					{
						what: "{{UserName}}",
						filler: (
							<Typography
								weight="bold"
								trackingId="user-name"
							>
								{computedDisplayName}
							</Typography>
						)
					},
					{
						what: "{{Title}}",
						filler: (
							<Typography
								weight="bold"
								trackingId="knowledge-item-title"
							>
								{title}
							</Typography>
						)
					}
				]}
			/>
		</span>
	);
};

KnowledgeItemCommentActivity.displayName = "KnowledgeItemCommentActivity";
